"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Delete = exports.Put = exports.setOrDeleteLabel = exports.Get = exports.getLabelsSimple = exports.getLabels = void 0;
const tslib_1 = require("tslib");
const vizportalclient_common_components_1 = require("@tableau/vizportalclient-common-components");
const canSubmitLabel_1 = require("./canSubmitLabel");
const ERROR_NOTIFYING_SERVER_RESPONSE_DELAY = 2000;
const partialConfig = {
    restApiVersion: '3.16',
    serverWideRequest: false,
    endpoint: 'labels',
};
function getLabels(params) {
    var _a;
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const { resolveOwners, transform } = params;
        if (resolveOwners) {
            throw new Error('Resolve owners is not implemented, getLabels should only be used for the actions menu');
        }
        const response = yield exports.Get.getLabelsSparse(params);
        const data = (_a = response.labelList.label) !== null && _a !== void 0 ? _a : [];
        const labels = (0, vizportalclient_common_components_1.groupByToMultimap)({
            data,
            keyTransform: (original) => ({ contentId: original.contentId, contentType: original.contentType.toLowerCase() }),
            valTransform: transform,
            keyBy: ({ contentId, contentType }) => `${contentType}-${contentId}`,
        });
        return labels;
    });
}
exports.getLabels = getLabels;
function getLabelsSimple(params) {
    var _a;
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const { resolveOwners } = params;
        if (resolveOwners) {
            throw new Error('Resolve owners is not implemented, getLabels should only be used for the actions menu');
        }
        const response = yield exports.Get.getLabelsSparse(params);
        const data = (_a = response.labelList.label) !== null && _a !== void 0 ? _a : [];
        return data;
    });
}
exports.getLabelsSimple = getLabelsSimple;
const getConfig = Object.assign(Object.assign({}, partialConfig), { httpMethod: 'POST' });
/**
 * getLabelsSparse is intended to be used for the set warning|certification action and
 * doesn't resolve user information because that is not required for the action
 *
 * @param params The list of assets to be queried for and the optional category to filtery by
 * @returns A collection of unresolved labels, i.e.: there is no owner or asset information
 */
function getLabelsSparse(params) {
    const request = contentItemsToContentList(params);
    const queryParams = makeLabelsQueryParams(params);
    const makeJsonRestApiRequest = params.makeJsonRestApiRequest;
    const result = makeJsonRestApiRequest(getConfig, request, queryParams);
    return result;
}
exports.Get = {
    getConfig,
    getLabelsSparse,
};
function setOrDeleteLabel(params) {
    var _a, _b;
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const { luid, labelContent, makeJsonRestApiRequest, category } = params;
        const command = (0, canSubmitLabel_1.canSubmitLabel)({
            active: (_a = labelContent === null || labelContent === void 0 ? void 0 : labelContent.active) !== null && _a !== void 0 ? _a : false,
            message: (_b = labelContent === null || labelContent === void 0 ? void 0 : labelContent.message) !== null && _b !== void 0 ? _b : '',
            category,
        });
        switch (command) {
            case 'DELETE':
                if (luid) {
                    return exports.Delete.deleteLabel({ luid, makeJsonRestApiRequest });
                }
                else {
                    return exports.Delete.deleteLabels(params);
                }
            case 'SUBMIT':
                return exports.Put.setLabels(params);
            case 'TOOLONG':
                throw new Error('The label message was too long to submit to the server');
            case 'NOMESSAGE':
                throw new Error('A message is required for a label to be submitted');
            default:
                (0, vizportalclient_common_components_1.assertUnreachable)(command);
                throw new Error('Unreachable');
        }
    });
}
exports.setOrDeleteLabel = setOrDeleteLabel;
const putConfig = Object.assign(Object.assign({}, partialConfig), { httpMethod: 'PUT' });
function setLabels(params) {
    const queryParams = makeLabelsQueryParams(params);
    const request = Object.assign(Object.assign({}, contentItemsToContentList(params)), { label: Object.assign({}, params.labelContent) });
    const makeJsonRestApiRequest = params.makeJsonRestApiRequest;
    const result = makeJsonRestApiRequest(putConfig, request, queryParams)
        .then((t) => tslib_1.__awaiter(this, void 0, void 0, function* () {
        var _a;
        yield (0, vizportalclient_common_components_1.delayPromise)((_a = params.delayOverride) !== null && _a !== void 0 ? _a : ERROR_NOTIFYING_SERVER_RESPONSE_DELAY);
        return t;
    }));
    return result;
}
exports.Put = {
    putConfig,
    setLabels,
};
function deleteLabels(params) {
    var _a;
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const config = Object.assign(Object.assign({}, partialConfig), { httpMethod: 'DELETE', endpoint: `labels` });
        const queryParams = makeLabelsQueryParams(params);
        const request = contentItemsToContentList(params);
        const makeJsonRestApiRequest = params.makeJsonRestApiRequest;
        const result = makeJsonRestApiRequest(config, request, queryParams);
        yield (0, vizportalclient_common_components_1.delayPromise)((_a = params.delayOverride) !== null && _a !== void 0 ? _a : ERROR_NOTIFYING_SERVER_RESPONSE_DELAY);
        return result;
    });
}
function deleteLabel({ luid, delayOverride, makeJsonRestApiRequest }) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const config = Object.assign(Object.assign({}, partialConfig), { httpMethod: 'DELETE', endpoint: `labels/${luid}` });
        const result = yield makeJsonRestApiRequest(config, undefined).then((t) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield (0, vizportalclient_common_components_1.delayPromise)(delayOverride !== null && delayOverride !== void 0 ? delayOverride : ERROR_NOTIFYING_SERVER_RESPONSE_DELAY);
            return t;
        }));
        return result;
    });
}
exports.Delete = {
    deleteLabels,
    deleteLabel,
};
function contentItemsToContentList(params) {
    return {
        contentList: {
            content: params.contentItems.map(i => ({ id: i.contentId, contentType: i.contentType })),
        },
    };
}
function makeLabelsQueryParams(params) {
    const { category } = params;
    if (!category) {
        return undefined;
    }
    return {
        categories: encodeURIComponent(category),
    };
}
//# sourceMappingURL=Labels.js.map